import InvoicingPeriod from '../constants/InvoicingPeriod';

export default class Subtotals {
  countToday = 0;
  countThisWeek = 0;
  countOlder = 0;
  amountToday = 0;
  amountThisWeek = 0;
  amountOlder = 0;

  getTotalAmount(): number {
    return this.amountOlder + this.amountToday + this.amountThisWeek;
  }

  getAmount(period: InvoicingPeriod): number {
    switch (period) {
      case InvoicingPeriod.TODAY:
        return this.amountToday;
      case InvoicingPeriod.THIS_WEEK:
        return this.amountThisWeek;
      case InvoicingPeriod.OLDER:
        return this.amountOlder;
    }
  }

  addAmount(amount: number, period: InvoicingPeriod): void {
    if (period === InvoicingPeriod.TODAY) {
      this.amountToday += amount;
    } else if (period === InvoicingPeriod.THIS_WEEK) {
      this.amountThisWeek += amount;
    } else if (period === InvoicingPeriod.OLDER) {
      this.amountOlder += amount;
    }
  }
}